document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll(
		'.wp-block-cancan-animated-svg'
	);

	const animations = {
		'hand-with-card-and-bubble__primary': animateHand,
		'hand-with-card-and-bubble__secondary': animateHand,
		'pizza-box-and-bubble': animatePizza,
		'question-mark-bubble': animateQuestionMark,
	};

	// Store GSAP animations per container
	const activeAnimations = new WeakMap();

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				const container = entry.target;
				const svg = container.querySelector('svg');
				const svgId = container.dataset.svgId;

				if (!svg || !svgId) return;

				let tweens = activeAnimations.get(container);

				if (entry.isIntersecting) {
					// Start animation if not already created
					if (!tweens) {
						const animation = animations[svgId];
						if (typeof animation === 'function') {
							tweens = animation(svg);
							activeAnimations.set(container, tweens);
						}
					} else {
						// Resume paused animations
						tweens.forEach((t) => t.play());
					}
				} else if (tweens) {
					// Pause all animations for this container
					tweens.forEach((t) => t.pause());
				}
			});
		},
		{
			threshold: 0.2,
		}
	);

	containers.forEach((container) => observer.observe(container));

	// --- Animations return tween references ---
	function animateHand(svg) {
		const percentage = svg.querySelector('.percentage');
		if (!percentage) return [];

		const tweens = [];

		const initialTween = gsap.to(percentage, {
			rotation: -5,
			transformOrigin: 'center center',
			duration: 0.6,
			ease: 'power1.inOut',
			onComplete: () => {
				gsap.set(percentage, { rotation: -5 });

				const rockingTween = gsap.to(percentage, {
					rotation: 10,
					duration: 1.2,
					ease: 'power1.inOut',
					yoyo: true,
					repeat: -1,
				});
				tweens.push(rockingTween); // store rocking tween for pause/resume
			},
		});

		tweens.push(initialTween); // store initial tween for pause/resume
		return tweens;
	}

	function animatePizza(svg) {
		const heart = svg.querySelector('.heart');
		const heatLines = svg.querySelectorAll('.heat-lines .heat-line');
		if (!heart || !heatLines.length) return [];

		const tweens = [];

		// Heartbeat
		const heartTween = gsap.to(heart, {
			scale: 1.2,
			duration: 0.8,
			ease: 'power1.inOut',
			yoyo: true,
			repeat: -1,
			repeatDelay: 0.1,
			transformOrigin: '50% 50%',
		});
		tweens.push(heartTween);

		// Heat lines animation
		heatLines.forEach((line, index) => {
			const lineTween = gsap.to(line, {
				y: -10 - index * 5,
				duration: 1 + Math.random(),
				ease: 'sine.inOut',
				yoyo: true,
				repeat: -1,
				transformOrigin: '50% 100%',
			});
			tweens.push(lineTween);
		});

		return tweens;
	}

	function animateQuestionMark(svg) {
		const questionMark = svg.querySelector('.question-mark');
		if (!questionMark) return [];

		const tweens = [];

		const pulseTween = gsap.to(questionMark, {
			scale: 1.2,
			duration: 0.8,
			ease: 'power1.inOut',
			yoyo: true,
			repeat: -1,
			repeatDelay: 0.1,
			transformOrigin: '50% 50%',
		});
		tweens.push(pulseTween);

		return tweens;
	}
});
